import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Components/Pages/Home/Home";
import Mint from "./Components/Pages/Mint/Mint";
import Radeem from "./Components/Pages/Radeem/Radeem";
import Farm from "./Components/Pages/Farms/Farm.js";
import Staking from "./Components/Pages/Staking/Staking";
// import Airdrop from "./Components/Pages/Airdrop/Airdrop";
// import Footer from "./Components/Footer.js";
// import Header from "./Components/Header.js";
import "./App.css";
import { Navbar } from "./Components/Navbar.jsx";
import NeuroEffect from "./Components/common/NeuroEffect.js";
import * as THREE from 'three';
import { Lock } from "./Components/Pages/Lock/Lock.jsx";
import Dashboard from "./Components/Pages/Dashboard/Dashboard.jsx";
import { Claim } from "./Components/Pages/Claim/Claim.jsx";



function App() {
  return (
    <div>
      <BrowserRouter>
        {/* <Header /> */}
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mint" element={<Mint />} />
          <Route path="/redeem" element={<Radeem />} />
          <Route path="/farm" element={<Farm />} />
          <Route path="/stake" element={<Staking />} />
          {/* <Route path="/airdrop" element={<Airdrop />} /> */}
          <Route path="/lock" element={<Lock />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/claim-reward" element={<Claim/>}/>

        </Routes>
        {/* <Footer /> */}
        {/* <NeuroEffect/> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
